import Button from '@components/v2/ui/Button/Button';
import LangEnum from '../../../lang/LangEnum';
import { startFederatedLogin } from '../../../services/modules/sso/sso.utils';
import { LoginPageTestIds } from '../../../utils/testIds/LoginPage.testIds';
import { useTranslation } from '../../translation/TranslationContext';
import { useAuthContext } from '../AuthContext';

interface FederatedLoginButtonProps {
  brandSlug: string;
}

const FederatedLoginButton = ({ brandSlug }: FederatedLoginButtonProps) => {
  const { translate } = useTranslation();
  const { redirectPath } = useAuthContext();

  const handleFederatedLogin = () => startFederatedLogin({ brandSlug, redirectPath });

  return (
    <Button
      variant="contained"
      color="secondary"
      size="large"
      fullWidth
      testId={LoginPageTestIds.FEDERATED_LOGIN_BUTTON}
      onClick={handleFederatedLogin}
    >
      {translate(LangEnum.LOGIN_ENTER_WITH_CORPORATE_EMAIL)}
    </Button>
  );
};

export default FederatedLoginButton;
